<template>
    <div class="spliceEffectWrapper">
        <div class="sliderWrapper mt-2">
            <div class="d-flex align-items-center justify-content-center">
                <label class="d-block text-xs font-semibold text-gray-700 uppercase tracking-widest mb-0 text-left w-24 !mb-0 !text-2xs">
                    thickness
                </label>
                <div class="flex-1">
                    <input type="range" @input="setThickness" :value="thickness" min="0" max="100" class="form-control-range" />
                </div>
                <div class="w-8 text-sm font-bold text-right text-gray-700 ml-2">{{thickness}}</div>
            </div>
        </div>
        <div class="sliderWrapper">
            <div class="d-flex align-items-center justify-content-center">
                <label class="d-block text-xs font-semibold text-gray-700 uppercase tracking-widest mb-0 text-left w-24 !mb-0 !text-2xs">
                    OFFSET
                </label>
                <div class="flex-1">
                    <input type="range" @input="setOffset" :value="offset" min="1" max="100" class="form-control-range" />
                </div>
                <div class="w-8 text-sm font-bold text-right text-gray-700 ml-2">{{offset}}</div>
            </div>
        </div>
        <div class="sliderWrapper mt-2">
            <div class="d-flex align-items-center justify-content-center">
                <label class="d-block text-xs font-semibold text-gray-700 uppercase tracking-widest mb-0 text-left w-24 !mb-0 !text-2xs">
                    DIRECTION
                </label>
                <div class="flex-1">
                    <input type="range" @input="setDirection" :value="direction" min="-180" max="180" class="form-control-range" />
                </div>
                <div class="w-8 text-sm font-bold text-right text-gray-700 ml-2">{{direction}}</div>
            </div>
        </div>
       
       
        <div class="colorWrapper mt-2">
            <div class="d-flex align-items-center justify-content-between">
                <label class="d-block text-xs font-semibold text-gray-700 uppercase tracking-widest mb-0 text-left w-24 !mb-0 !text-2xs">
                    COLOR
                </label>
                <verte @input="setColor" v-model="color" picker="square" menuPosition="top" model="hex"></verte>
            </div> 
        </div>

    </div>
</template>

<script>
import verte from 'verte';
import 'verte/dist/verte.css';
export default {
    name:"SpliceEffect",
    components: { verte },
    data(){
        return{
            color:"",
            offset:"50",
            direction:"-45",
            thickness:"50",
        }
    },
    computed:{
        getObjProperties(){
            return this.$store.getters.getActiveObjectprops
        },
       
    },
    watch:{
        getObjProperties :{
          handler(updatedValues) {
            
            this.color = updatedValues.effectType.color;
            this.offset = updatedValues.effectType.offset;
            this.direction = updatedValues.effectType.direction;
            this.thickness = updatedValues.effectType.thickness;
                
            },
            deep: true,
            immediate: true
        }
    },
    methods:{
        setColor(e){
            
            this.color = e;
            this.$store.dispatch("setCurrentObjectProperties" , { effectType: this.createSplice() });
        },
        setOffset(e){
            
            this.offset = e.target.value;
            this.$store.dispatch("setCurrentObjectProperties" , { effectType: this.createSplice() });
        },
        setDirection(e){
            
            this.direction = e.target.value;
            this.$store.dispatch("setCurrentObjectProperties" , { effectType: this.createSplice() });
        },
        setThickness(e){
            
            this.thickness = e.target.value;
            this.$store.dispatch("setCurrentObjectProperties" , { effectType: this.createSplice() });
        },
        createSplice(){
            
            let obj = {
              type:"splice",
              color:this.color,
              offset:this.offset,
              direction:this.direction,
              thickness : this.thickness
            };
  
              return obj
          }
       
    }
}
</script>
<style scoped>
.colorWrapper{
    padding: 0 19px;
}

</style>